<template>
	<div class="leftres">
		<div>
			<div class="inputtopp">
				<div v-for="(item, index) of formdata" :key="index" class="search-item">
					<Commondropdownlist ref="seselect" :widthRight="item.widthRight" :widthLeft="item.widthLeft"
						:heightLeft="item.heightLeft" :heightRight="item.heightRight" :lablewith="item.lablewith"
						:options="item.options" :inputdata="item.inputdata" :title="item.title"
						:fontSize="item.fontSize" :color="item.color" :placeholder="item.placeholder"
						:multiple="item.multiple" :types="item.types" :inputtype="item.inputtype" :width="item.width"
						:event="item.event">
					</Commondropdownlist>
				</div>
				<div class="Btngroups">
					<CommonBtngroup :show="false" :qhide="false" @select="select" @reset="reset"></CommonBtngroup>
				</div>
			</div>

			<!-- Master Table -->
			<div class="TableBox"
				style="box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); margin-top: 10px; background-color: #FFFFFF;">
				<ActivityListTable ref="masterTable" :tableData="tableData" :total="total"
					@handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"
					@onRowClick="onRowClick" @reload="getList" @Export="handleExport">
				</ActivityListTable>
			</div>

			<!-- Detail Table -->
			<div class="TableBox"
				style="box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); margin-top: 10px; background-color: #FFFFFF; padding: 10px;">
				<ActivityDetailTable :tableData="detailData"></ActivityDetailTable>
			</div>
		</div>
	</div>
</template>

<script>
	import Commondropdownlist from "@/components/common-dropdownlist.vue";
	import CommonBtngroup from "@/components/commongroup.vue";
	import ActivityListTable from "./components/ActivityListTable.vue";
	import ActivityDetailTable from "./components/ActivityDetailTable.vue";
	import {
		ActivityList,
		ActivityDetail,
		ActivityExport
	} from "@/api/ActivityList";
	import utils from "@/common/utils";

	export default {
		components: {
			Commondropdownlist,
			CommonBtngroup,
			ActivityListTable,
			ActivityDetailTable
		},
		data() {
			return {
				total: 0,
				pageindex: 1,
				pageSize: 20,
				tableData: [],
				detailData: [],
				form: {
					ActivityName: '',
					Hospital: '',
					LEVEL2: '',
					CreateTime1: '',
					CreateTime2: '',
					PreConductDate1: '',
					PreConductDate2: ''
				},
				formdata: [{
						inputdata: "",
						title: "活动名称",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "",
						inputtype: "input",
						width: "190px",
						lablewith: "80px",
					},
					{
						inputdata: "",
						title: "医院",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "",
						inputtype: "input",
						width: "190px",
						lablewith: "80px",
					},
					{
						inputdata: "",
						title: "会议类型",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "",
						inputtype: "input",
						width: "190px",
						lablewith: "80px",
					},
					{
						inputdata: "",
						title: "创建时间",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请选择",
						types: "daterange",
						inputtype: "date",
						width: "240px",
						lablewith: "75px",
					},
					{
						inputdata: "",
						title: "举办时间",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请选择",
						types: "daterange",
						inputtype: "date",
						width: "240px",
						lablewith: "80px",
					}
				],
			};
		},
		mounted() {
			this.getList();
		},
		methods: {
			async getList() {
				let res = await ActivityList({
					...this.form,
					pageSize: this.pageSize,
					pageIndex: this.pageindex,
				});
				if (res.code == 0) {
					this.total = res.data.Count;
					this.tableData = res.data.data;
					this.detailData = [];
				}
			},
			reset() {
				this.$refs.seselect.map((item, index) => {
					item.modelvalue = "";
					if (index === 3 || index === 4) {
						item.startTime = "";
						item.endTime = "";
					}
				});
				this.form = {
					ActivityName: '',
					Hospital: '',
					LEVEL2: '',
					CreateTime1: '',
					CreateTime2: '',
					PreConductDate1: '',
					PreConductDate2: ''
				};
			},
			select() {
				this.pageindex = 1;
				this.form.ActivityName = this.$refs.seselect[0].modelvalue;
				this.form.Hospital = this.$refs.seselect[1].modelvalue;
				this.form.LEVEL2 = this.$refs.seselect[2].modelvalue;
				this.form.CreateTime1 = this.$refs.seselect[3].startTime;
				this.form.CreateTime2 = this.$refs.seselect[3].endTime;
				this.form.PreConductDate1 = this.$refs.seselect[4].startTime;
				this.form.PreConductDate2 = this.$refs.seselect[4].endTime;
				this.getList();
			},
			handleCurrentChange(pageindex) {
				this.pageindex = pageindex;
				this.getList();
			},
			handleSizeChange(paegSzie) {
				this.pageSize = paegSzie;
				this.getList();
			},
			async onRowClick(row) {
				if (!row || !row.ActivityCode) return;
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				try {
					let res = await ActivityDetail({
						ActivityCode: row.ActivityCode
					});
					if (res.code == 0) {
						this.detailData = res.data;
					}
				} finally {
					loading.close();
				}
			},
			async handleExport() {
				let res = await ActivityExport({
					...this.form,
					pageSize: this.pageSize,
					pageIndex: this.pageindex,
				});
				if (res) {
					utils.downloadFile(res, "活动档案", "xlsx");
				} else {
					this.$message.warning("导出失败");
				}
			}
		},
	};
</script>

<style lang="less" scoped>
	.inputtopp {
		width: 100%;
		height: auto;
		min-height: 85px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 15px;
		padding-bottom: 5px;
		/* overflow: hidden; Removed to allow dropdowns to show and use flex wrap */
		position: relative;
		transition: all 0.3s;
		margin-bottom: 10px;
		display: flex;
		flex-wrap: wrap;
		align-items: flex-start;
	}

	.search-item {
		margin-right: 10px;
		margin-bottom: 10px;
	}

	.Btngroups {
		/* display: inline-block; */
		/* float: right; Removed float */
		margin-left: auto;
		/* Push to right */
		margin-top: 5px;
		margin-right: 20px;
		margin-bottom: 10px;
	}
</style>
